import { find, uniqBy, flatMap, isEmpty } from 'lodash';
import { TripTypes } from '@model/common';
import { GlobalAppState } from '@model/state';
import { createSelector } from 'reselect';

interface PathAndTripType {
  path: string;
  tripType: TripTypes;
}

export const getNavOffers = (state: GlobalAppState) => state.cms.navOffers;
export const getNavInfo = (state: GlobalAppState) => state.cms.navInfo;

const getParams = (_, params) => params;
export const getNavDestinations = (state: GlobalAppState) => state.cms.navDestinations;

const getDestinationByPathAndTripType = createSelector(
  getNavDestinations,
  getParams,
  (tripTypes, { path: findPath, tripType }) =>
    tripTypes && !isEmpty(tripTypes) && find(tripTypes[tripType].destinations, { path: findPath })
);

export const getNavDestinationByPathAndTripType = (props: PathAndTripType) => (state: GlobalAppState) =>
  !props.tripType || props.tripType === TripTypes.ALL
    ? getDestinationByPath(state, props.path)
    : getDestinationByPathAndTripType(state, props);

const getDestinationByPath = createSelector(
  getNavDestinations,
  getParams,
  (tripTypes, findPath) =>
    tripTypes &&
    findPath &&
    find(uniqBy(flatMap(Object.values(tripTypes || {}), 'destinations'), 'path'), {
      path: findPath
    })
);

export const getNavDestinationByPath = (path: string) => (state: GlobalAppState) => getDestinationByPath(state, path);

const getDestinationsByPath = createSelector(getNavDestinations, getParams, (tripTypes, paths) =>
  tripTypes && paths && paths.length > 0
    ? paths.map((findPath) =>
        find(uniqBy(flatMap(Object.values(tripTypes || {}), 'destinations'), 'path'), {
          path: findPath
        })
      )
    : []
);

export const getNavDestinationsByPath = (paths: Array<string>) => (state: GlobalAppState) =>
  getDestinationsByPath(state, paths);
